import React, { useState, useEffect } from 'react';
import {
  Button,
  Table,
  Input,
  Badge,
  Spinner,
  Card,
  CardBody
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FaFileInvoice, FaTruck, FaSearch, FaCheckCircle, FaClock, FaMoneyBillWave } from 'react-icons/fa';
import { formatPrice } from '../../helpers/utility';
import './DocumentSelectionModal.css'; // Assuming you have some custom styles
const DocumentSelectionTablet = ({
  typeDocument,
  documents,
  loading,
  selectedDocuments,
  onDocumentsSelected
}) => {
  const { t } = useTranslation();
  const [localSelectedDocs, setLocalSelectedDocs] = useState([]);

  useEffect(() => {
    if (!selectedDocuments) return;
    setLocalSelectedDocs(selectedDocuments);
  }, [selectedDocuments]);

  const toggleSelection = (document) => {
    setLocalSelectedDocs(prev =>
      prev.some(d => d.id === document.id)
        ? prev.filter(d => d.id !== document.id)
        : [...prev, document]
    );
  };

  const confirmSelection = () => {
    onDocumentsSelected?.(localSelectedDocs);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" />
        <div className="mt-2 text-muted">{t('common.loading')}</div>
      </div>
    );
  }


  const totalRestant = localSelectedDocs.reduce((sum, doc) => {
    const montantPaye = doc.montantRegle || doc.montantPaye || 0;
    const restant = (doc.montantTotalTTC || 0) - montantPaye;
    return sum + Math.max(restant, 0);
  }, 0);


  return (
    <div className="tablet-document-container">

      {/* DOCUMENT LIST */}
      <div className="tablet-documents-list">
        {documents?.map(document => {
          const montantPaye = document.montantRegle || document.montantPaye || 0;
          const restant = document.montantTotalTTC - montantPaye;
          const isSelected = localSelectedDocs.some(d => d.id === document.id);

          if (restant <= 0) return null;

          return (
            <Card
              key={document.id}
              className={`tablet-document-card ${isSelected ? 'selected' : ''}`}
              onClick={() => toggleSelection(document)}
            >
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <strong className="fs-5">
                    {typeDocument === 'FACTURE' ? <FaFileInvoice /> : <FaTruck />}
                    {' '}
                    {document.numero}
                  </strong>

                  {isSelected && (
                    <FaCheckCircle className="text-success fs-4" />
                  )}
                </div>

                <div className="text-muted mb-2">
                  {document.clientNom}
                </div>

                <div className="d-flex justify-content-between">
                  <div>
                    <div className="small text-muted">{t('reglement.total')}</div>
                    <strong>{formatPrice(document.montantTotalTTC, false)} DH</strong>
                  </div>

                  <div>
                    <div className="small text-muted">{t('reglement.restant')}</div>
                    <strong className="text-danger">
                      {formatPrice(restant, false)} DH
                    </strong>
                  </div>
                </div>

                <div className="mt-2">
                  <Badge color={montantPaye === 0 ? 'danger' : 'warning'}>
                    <FaMoneyBillWave className="me-1" />
                    {montantPaye === 0
                      ? t('reglement.impaye')
                      : t('reglement.partiel')}
                  </Badge>
                </div>
              </CardBody>
            </Card>
          );
        })}
      </div>

      {/* STICKY CONFIRM BAR */}
      {localSelectedDocs.length > 0 && (
        <div className="tablet-confirm-bar">
          <div className="confirm-summary">
            <div>
              <strong>{localSelectedDocs.length}</strong>{" "}
              {t('reglement.documentsSelectionnes')}
            </div>

            <div className="text-danger fw-bold">
              {t('reglement.restantTotal')} :{" "}
              {formatPrice(totalRestant, false)} DH
            </div>
          </div>

          <Button
            color="success"
            size="lg"
            onClick={confirmSelection}
          >
            <FaCheckCircle className="me-2" />
            {t('reglement.confirmerSelection')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default DocumentSelectionTablet;
